export default "__VITE_ASSET__179f9f25__"